exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "p{\n    margin-top: 100px;\n}\n\n.user-input {\n    width: 200px;\n    height: 40px;\n    display: inline;\n    font-size: 3rem;\n    font-weight: bold;\n}\n\n.card-title {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.card-container {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n}\n.card {\n    background-color: lightblue;\n    padding: 10px 40px 20px;\n    margin: 20px;\n    border-radius: 5px;\n}\n\n.card ul {\n    margin: 0;\n    padding: 0;\n}\n\nul li {\n    list-style-type: square;\n}\n\n#btnSave { \n    width: 100%;\n}\n\n.mtl {\n    margin-top: 20px;\n}\n\n@media screen and (min-width: 786px) {\n    .card {\n        min-width: 300px;\n        max-width: 300px;\n    }\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/kepler/code/github/expense-manager-firebase/src/app/home/home.component.css
// module id = ../../../../../src/app/home/home.component.css
// module chunks = 1